module.exports = __webpack_public_path__ + "img/bold-checkbox-partial-selected.a091e0e2.svg";